import dicePng from '/img/icons/dice.png';
import diceWebp from '/img/icons/dice.webp';

export const diceImages = {
  icon: {
    png: dicePng,
    webp: diceWebp,
  },
};
